import React from 'react';
import Reveal, { RevealGroup } from './ui/Reveal';
import SectionLabel from './ui/SectionLabel';
import useParallax from '../hooks/useParallax';
import photo from '../lib/images';
import { vision } from '../data/content';

export default function Vision() {
  const parallaxRef = useParallax({ strength: 0.1 });

  return (
    <section id="vision" className="on-dark grain relative isolate overflow-hidden bg-ink-900 py-24 sm:py-32">
      <div ref={parallaxRef} className="absolute inset-0 -z-20 will-change-transform">
        <img {...photo('vision-bg')} sizes="100vw" alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" />
      </div>
      <div
        className="absolute inset-0 -z-10 bg-gradient-to-r from-ink-900 via-ink-900/88 to-ink-900/50"
        aria-hidden="true"
      />

      <div className="shell relative grid gap-14 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:items-center lg:gap-16">
        <div>
          <Reveal variant="fade">
            <SectionLabel index="04" tone="light">
              The Vision
            </SectionLabel>
          </Reveal>

          <Reveal
            as="h2"
            delay={80}
            className="mt-7 font-display text-[2rem] font-semibold uppercase leading-[1.06] tracking-[0.01em] text-white sm:text-4xl lg:text-[3rem]"
          >
            The vision we are building toward
          </Reveal>
          <Reveal variant="rule" delay={240} className="rule mt-7" />

          <Reveal as="p" delay={300} className="mt-8 max-w-md text-[0.98rem] leading-relaxed text-cream/75">
            {vision.body}
          </Reveal>

          <Reveal delay={380} className="mt-9 border-l-2 border-gold pl-6">
            <p className="text-[0.98rem] leading-relaxed text-cream/50">{vision.goal.not}</p>
            <p className="mt-1.5 font-display text-xl uppercase tracking-[0.06em] text-gold sm:text-2xl">
              {vision.goal.is}
            </p>
            <p className="mt-2.5 text-[0.98rem] leading-relaxed text-cream/75">{vision.goal.then}</p>
          </Reveal>
        </div>

        {/* The scrim keeps the gold line art legible where the sunset behind
            it is brightest. */}
        <RevealGroup
          as="ul"
          variant="scale"
          stagger={55}
          className="grid grid-cols-2 border-l border-t border-cream/10 bg-ink-900/50 backdrop-blur-[3px] sm:grid-cols-3 lg:grid-cols-6"
        >
          {vision.items.map((item) => (
            <li
              key={item.title}
              className="group flex flex-col items-center gap-3.5 border-b border-r border-cream/10 px-3 py-7 text-center transition-colors duration-500 hover:bg-gold/[0.07]"
            >
              <img
                src={item.icon}
                alt=""
                width="192"
                height="192"
                loading="lazy"
                className="h-11 w-11 object-contain transition-transform duration-500 ease-out-expo group-hover:-translate-y-1 group-hover:scale-110"
              />
              <span className="font-display text-[0.68rem] font-medium uppercase leading-snug tracking-[0.12em] text-cream/75 transition-colors duration-300 group-hover:text-cream">
                {item.title}
              </span>
            </li>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
